import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Input from '../../components/input';
import Loading from '../../components/loading';
import SelectMultiple from '../../components/selectMultiple';
import { createTaxHarvestingSnapshot, getTaxHarvestingPortfolios, getTaxHarvestingSnapshotById, getTaxHarvestingSnapshots, getTaxHarvestingSnapshotByDate, getTaxHarvestingLots } from "../../actions/taxHarvesting";
import { deviceLanguage } from '../../helpers/getLocale';
import SelectMultipleEditable from "../../components/selectMultipleEditable";

const formatApiDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const TaxHarvestingGeneralSearch = (props) => {
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(null);
  const [client, setClient] = useState(null);
  const [clientOptions, setClientOptions] = useState(null);
  const [portfoliosLoading, setPortfoliosLoading] = useState(true);
  const portfoliosRequest = useRef(0);

  const [clientType, setClientType] = useState(null);
  const [clientTypeOptions, setClientTypeOptions] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [valuationDate, setValuationDate] = useState('');
  const [datepickerDays, setDatepickerDays] = useState({ end_date: endDate });

  const [portfolios, setPortfolios] = useState([]);

  const [clientHoldings, setClientHoldings] = useState([]);
  const [clientHoldingOptions, setClientHoldingOptions] = useState([]);
  const [clientHoldingSelected, setClientHoldingSelected] = useState('');
  const [clientAccounts, setClientAccounts] = useState([]);
  const [clientAccountOptions, setClientAccountOptions] = useState([]);
  const [clientAccountSelected, setClientAccountSelected] = useState('');

  const [snapshot, setSnapshot] = useState(null);
  const [snapShotId, setSnapShotId] = useState(null);
  const [noSnapshotForDate, setNoSnapshotForDate] = useState(false);
  const [snapshotGenerationStatus, setSnapshotGenerationStatus] = useState(null);
  const snapshotPollingTimer = useRef(null);
  const snapshotRequest = useRef(0);

  const [consultButtonActive, setConsultButtonActive] = useState(true);

  const [lots, setLots] = useState({});

  useEffect(() => {
    getPortfolios();
  }, [])

  useEffect(() => () => {
    clearTimeout(snapshotPollingTimer.current);
  }, [])

  const stopSnapshotPolling = () => {
    clearTimeout(snapshotPollingTimer.current);
    snapshotPollingTimer.current = null;
  }

  const getPortfolios = (groupId = null) => {
    const requestId = ++portfoliosRequest.current;
    setPortfoliosLoading(true);

    props.getTaxHarvestingPortfolios(
      props.authentication_token,
      groupId,
      (response) => portfoliosSuccess(response, groupId, requestId),
      () => portfolioError(requestId)
    );
  }
  const portfoliosSuccess = (response, requestedGroupId, requestId) => {
    if (requestId !== portfoliosRequest.current) return;

    const availableGroups = response.groups || [];
    setGroups(availableGroups);

    // A single authorized group does not need a visible selector. Load its
    // portfolios with group_id so clients from other groups never leak in.
    if (!requestedGroupId && availableGroups.length === 1) {
      setGroup(availableGroups[0]);
      getPortfolios(availableGroups[0].group_id);
      return;
    }

    // With more than one group, wait until the user chooses one instead of
    // showing the unfiltered compatibility response.
    if (!requestedGroupId && availableGroups.length > 1) {
      prepareClientSelectOptions([]);
      setPortfoliosLoading(false);
      return;
    }

    prepareClientSelectOptions(response.portfolios || []);
    setPortfoliosLoading(false);
  }
  const portfolioError = (requestId) => {
    if (requestId !== portfoliosRequest.current) return;

    setPortfoliosLoading(false);
    console.log("portfolioError")
  }

  const prepareClientSelectOptions = (portfolios) => {
    setPortfolios(portfolios)
    setClientOptions(portfolios.map((p) => ({ id: p.portfolio_id, value: `<span>${p.portfolio_name}</span> <span>${p.portfolio_id}</span>` })))
  }

  const prepareGroup = (options) => {
    const selectedGroup = options.item;
    setGroup(selectedGroup);
    setClient(null);
    setClientOptions(null);
    setPortfolios([]);
    setClientType(null);
    resetFilters();
    stopSnapshotPolling();
    snapshotRequest.current += 1;
    setNoSnapshotForDate(false);
    setSnapshotGenerationStatus(null);
    props.setSnapshot(null);
    setLots({});
    getPortfolios(selectedGroup.group_id);
  }

  const prepareClientTypeSelectOptions = (client, portfolios) => {
    const clientPortfolio = portfolios.find(p => p.portfolio_id === client.id)
   
    const clientHoldings = clientPortfolio.latest_snapshot.holding_companies || []
    const clientAccounts = clientPortfolio.latest_snapshot.accounts || []

    const clientTypeOptions = [
      {
        id: "client",
        value: "Client"
      },
      {
        id: "holding_company",
        value: "Holding Company"
      },
      {
        id: "account",
        value: "Accounts"
      }
    ]

    setClientHoldings(clientHoldings)
    setClientAccounts(clientAccounts)

    setClientTypeOptions(clientTypeOptions)
  }

  // The third selector is shared by holdings and accounts, according to type.
  useEffect(() => {
    if (clientType && clientType.id === "holding_company") {
      prepareClientHoldingSelectOptions();
    } else if (clientType && clientType.id === "account") {
      prepareClientAccountSelectOptions();
    } else {
      resetFilters()
    }
  }, [clientType]) 

  const prepareClientHoldingSelectOptions = () => {
    const selectOptions = clientHoldings.map(holding => {
      return {
        id: holding.holding_company_id,
        value: holding.holding_company_name
      }
    })
    setClientHoldingOptions(selectOptions)
  }
  const resetHolding = () => {
    setClientHoldingOptions([])
    setClientHoldingSelected('')
  }
  const prepareClientAccountSelectOptions = () => {
    const selectOptions = clientAccounts.map(account => {
      return {
        id: account.custodian,
        value: account.account_number
      }
    })
    setClientAccountOptions(selectOptions)
  }
  const resetAccount = () => {
    setClientAccountOptions([])
    setClientAccountSelected('')
  }
  const resetFilters = () => {
    resetHolding()
    resetAccount()
  }


  // if there is a client prepare dates and get snapshot by id to show cards
  useEffect(() => {
    // if (!client) {
    //   const spanshotId = portfolios.find(p => p.portfolio_id === client.id).latest_snapshot.id
    //   setSnapShotId(spanshotId)
    //   return;
    // }
    if (!client) return;
    resetFilters()
    setClientType(null)
    stopSnapshotPolling()
    snapshotRequest.current += 1
    setNoSnapshotForDate(false)
    setSnapshotGenerationStatus(null)
    props.setSnapshot(null)
    prepareDatePickerDates();
    // Set client type options after client is elected
    prepareClientTypeSelectOptions(client, portfolios)
    prepareValuationDate(client)

  }, [client])

  const prepareValuationDate = (client) => {
    const clientPortfolio = portfolios.find(p => p.portfolio_id === client.id)
    setValuationDate(new Date(clientPortfolio.latest_snapshot.valuation_date))
  }

  const goConsultation = (selectedValuationDate = valuationDate) => {
    if (!client) return;  
    if (selectedFilter === '') {
      getTaxSnapshotsByDate(selectedValuationDate);
    }else {
      getTaxSnapshotsById();
    }
  }

  const handleValuationDateChange = (date) => {
    setValuationDate(date);

    // Match the Consultar button: a date change only reloads when a query
    // can already be made with the current client and filters.
    if (!consultButtonActive) {
      goConsultation(date);
    }
  }
  const goConsultationYear = () => {
    if (!client) return;  
    // getTaxSnapshotsByDate({year: true});
    alert("consultar año")
  }

  const prepareDatePickerDates = () => {
    const clientData = portfolios.find(p => p.portfolio_id === client.id)

    // prepare start day
    const getStartDate = clientData.latest_snapshot.start_date;
    const startDayFormatted = new Date(getStartDate).toLocaleDateString(deviceLanguage);
    setStartDate(startDayFormatted); 

    // prepare end day
    // const today = new Date();
    // const yesterday = new Date(today);
    // const newEndDate = yesterday.setDate(today.getDate() - 1);

    const getEndDate = clientData.latest_snapshot.end_date;
    const endDayFormatted = new Date(getEndDate).toLocaleDateString(deviceLanguage);
    setEndDate(endDayFormatted);

    // setDatepickerDays({ start_date: new Date(getStartDate), end_date: newEndDate});
    setDatepickerDays({ start_date: new Date(getStartDate), end_date: new Date(getEndDate)});
  }
  useEffect(() => {
    console.log("snapshot id changed ==> ", snapShotId)
  }, [snapShotId])

  const getTaxSnapshotsById = () => {
    // const snapshot = portfolios.find(p => p.portfolio_id === client.id).latest_snapshot
    // const snapshot = portfolios.find(p => p.portfolio_id === client.id)
    // console.log("snapshot => ", snapshot)

    console.log("snapshotId inside getting snapshot by id => ", snapShotId)
    props.getTaxHarvestingSnapshotById({
      authenticationToken: props.authentication_token,
      id: snapShotId,
      accountNumbers: clientType.id === 'account' ? clientAccountSelected : '',
      holdingCompanyIds: clientType.id === 'holding_company' ? clientHoldingSelected : '',
      success: (snapshotData) => getTaxSnapshotsByIdSuccess(snapshotData), 
      error: () => getTaxSnapshotsByIdError()
    })
  }
  const getTaxSnapshotsByIdSuccess = (snapshot) => {
    setSnapshot(snapshot); 
    getTaxLotsOpen(snapshot);
    props.setSnapshot(snapshot)
  }

  const getTaxSnapshotsByIdError = () => {
    console.log("by id error")
  }
  useEffect(() => {
    props.setLots(lots)
  }, [lots])

  const getTaxLotsOpen = (snapshot) => {
    props.getTaxHarvestingLots({
      authenticationToken: props.authentication_token, 
      snapshotId: snapshot.id, 
      tickerSymbol: "", // ""AAPL" => tickerSymbol,
      accountNumbers: clientType.id === 'account' ? clientAccountSelected : '',
      holdingCompanyIds: clientType.id === 'holding_company' ? clientHoldingSelected : '',
      positionType: "open",  // position
      page: 1, 
      perPage: 100, 
      success: (data) => {
        setLots((prev) => { return {...prev, open: data.lots} } )
        getTaxLotsClosed(snapshot);
      }, 
      error: () => console.log("open lots error")
    });
  }

  const getTaxLotsClosed = (snapshot) => {
    props.getTaxHarvestingLots({
      authenticationToken: props.authentication_token, 
      snapshotId: snapshot.id, 
      tickerSymbol: "", // ""AAPL" => tickerSymbol,
      accountNumbers: clientType.id === 'account' ? clientAccountSelected : '',
      holdingCompanyIds: clientType.id === 'holding_company' ? clientHoldingSelected : '',
      positionType: "closed",  // position
      page: 1, 
      perPage: 100, 
      success: (data) => {
        setLots((prev) => { return {...prev, closed: data.lots} }) 
      }, 
      error: () => console.log("closed lots error")
    });
  }



  const getTaxSnapshotsByDate = (selectedValuationDate = valuationDate) => {
    if(!selectedValuationDate) return;

    const requestId = ++snapshotRequest.current;
    stopSnapshotPolling();
    setNoSnapshotForDate(false);
    setSnapshotGenerationStatus(null);
    const formattedValuationDate = formatApiDate(selectedValuationDate);

    props.getTaxHarvestingSnapshotByDate({
      authenticationToken: props.authentication_token, 
      portfolioId: client.id, 
      valuationDate: formattedValuationDate,
      success: (snapshots) => getTaxHarvestingSnapshotByDateSuccess(snapshots, selectedValuationDate, requestId),
      error: () => getTaxHarvestingSnapshotByDateError()
    })
  }
  const getTaxHarvestingSnapshotByDateSuccess = (snapshots, selectedValuationDate, requestId) => {
    if (requestId !== snapshotRequest.current) return;

    const selectedSnapshot = snapshots && snapshots[0];

    if (!selectedSnapshot) {
      setSnapshot(null);
      setSnapShotId(null);
      setLots({});
      setNoSnapshotForDate(true);
      props.setSnapshot(null);
      requestSnapshotForDate(selectedValuationDate, requestId);
      return;
    }

    setSnapshot(selectedSnapshot);
    setSnapShotId(selectedSnapshot.id)
    getTaxLotsOpen(selectedSnapshot);
    props.setSnapshot(selectedSnapshot)
  }

  const requestSnapshotForDate = (selectedValuationDate, requestId) => {
    setSnapshotGenerationStatus('pending');
    props.createTaxHarvestingSnapshot({
      authenticationToken: props.authentication_token,
      portfolioId: client.id,
      startDate: formatApiDate(new Date(selectedValuationDate.getFullYear() - 1, 11, 31)),
      endDate: formatApiDate(selectedValuationDate),
      success: (createdSnapshot) => {
        if (requestId !== snapshotRequest.current) return;

        if (!createdSnapshot) {
          setSnapshotGenerationStatus('failed');
          return;
        }

        if (createdSnapshot.status === 'completed') {
          setNoSnapshotForDate(false);
          setSnapshotGenerationStatus(null);
          getTaxSnapshotsByIdSuccess(createdSnapshot);
          return;
        }

        if (createdSnapshot.status === 'failed') {
          setSnapshotGenerationStatus('failed');
          return;
        }

        pollSnapshot(createdSnapshot.id, requestId);
      },
      error: () => {
        if (requestId === snapshotRequest.current) setSnapshotGenerationStatus('failed');
      }
    });
  }

  const pollSnapshot = (snapshotId, requestId) => {
    snapshotPollingTimer.current = setTimeout(() => {
      props.getTaxHarvestingSnapshotById({
        authenticationToken: props.authentication_token,
        id: snapshotId,
        success: (polledSnapshot) => {
          if (requestId !== snapshotRequest.current) return;

          if (polledSnapshot.status === 'completed') {
            setNoSnapshotForDate(false);
            setSnapshotGenerationStatus(null);
            getTaxSnapshotsByIdSuccess(polledSnapshot);
          } else if (polledSnapshot.status === 'failed') {
            setSnapshotGenerationStatus('failed');
          } else {
            pollSnapshot(snapshotId, requestId);
          }
        },
        error: () => {
          if (requestId === snapshotRequest.current) setSnapshotGenerationStatus('failed');
        }
      });
    }, 3000);
  }
  const getTaxHarvestingSnapshotByDateError = () => {
    console.log("snapshots by dates error !!")
  }

  // if (clientOptions === null && clientTypeOptions === null) {
  //   return <div>Loading...</div>
  // }
  
  const buttonIsActive = () => {
    if (clientType && clientType.id === 'client') {
      setConsultButtonActive(false)
    } else if (selectedFilter !== '') {
        setConsultButtonActive(false)
    } else {
        setConsultButtonActive(true)
    }
  }

  useEffect(() => {
    buttonIsActive()
  }, [clientType, clientHoldingSelected, clientAccountSelected])

  const prepareClient = (options) => {
    setClient(options.item)
    resetFilters()


    console.log("AAAAAAAAAAAAAa", options.item)
    const spanshotId = portfolios.find(p => p.portfolio_id === options.item.id).latest_snapshot.id
    setSnapShotId(spanshotId)
  }

  const isHoldingCompany = clientType && clientType.id === 'holding_company'
  const isAccount = clientType && clientType.id === 'account'
  const clientFilterOptions = isHoldingCompany ? clientHoldingOptions : isAccount ? clientAccountOptions : []
  const selectedFilter = isHoldingCompany ? clientHoldingSelected : isAccount ? clientAccountSelected : ''
  const filterLabel = isHoldingCompany ? 'Holding Company' : 'Accounts'

  return (
    <div className="c-tax-harvesting-general-search">
      {portfoliosLoading && <Loading />}
      <div className="c-tax-harvesting-general-search__header">
        <h2 className="c-tax-harvesting-general-search__title">Tax Harvesting</h2>
      </div>

      <div className="c-tax-harvesting-general-search__body">
        <div className="c-tax-harvesting-general-search__row">
          {groups.length > 1 && (
          <div className="c-tax-harvesting-general-search__field">
            <SelectMultiple
              disabled={groups.length === 0}
              setRef={() => {}}
              defaultValue={group ? group.value : 'Select'}
              colorGrey={true}
              label="Group"
              options={groups.map((item) => ({
                ...item,
                id: item.group_id,
                value: item.group_name || item.group_id
              }))}
              multiple={false}
              getOptions={prepareGroup}
              openOptions={() => {}}
              optionsNoAbsolute={true}
            />
          </div>
          )}
          <div className="c-tax-harvesting-general-search__field">
            {clientOptions && (
              <SelectMultiple
                disabled={clientOptions.length === 0}
                setRef={() => {}}
                hasHtml={true}
                defaultValue={client ? client.value : 'Select'}
                colorGrey={true}
                label="Client"
                options={clientOptions}
                multiple={false}
                getOptions={(options) => {
                  prepareClient(options)
                }}
                openOptions={() => {}}
                optionsNoAbsolute={true}
              />
            )}
          </div>
          <div className="c-tax-harvesting-general-search__field">
            {clientTypeOptions && (
            <SelectMultiple
              disabled={clientTypeOptions.length === 0}
              setRef={() => {}}
              defaultValue={clientType ? clientType.value : 'Select'}
              colorGrey={true}
              label="Type"
              options={clientTypeOptions}
              multiple={false}
              getOptions={(options) => setClientType(options.item)}
              openOptions={() => {}}
              optionsNoAbsolute={true}
            />
            )}
          </div>
          {(isHoldingCompany || isAccount) && (
          <div className="c-tax-harvesting-general-search__field">
            <SelectMultiple
              disabled={clientFilterOptions.length === 0}
              setRef={() => {}}
              defaultValue={selectedFilter ? selectedFilter : 'Select'}
              colorGrey={true}
              label={filterLabel}
              options={clientFilterOptions}
              multiple={true}
              getOptions={(options) => {
                if (isHoldingCompany) {
                  setClientHoldingSelected(options.map(holding => holding.id).join(', '))
                } else if (isAccount) {
                  setClientAccountSelected(options.map(account => account.value).join(', '))
                }
              }}
              openOptions={() => {}}
              optionsNoAbsolute={true}
            />
          </div>
          )}
        </div>

        <div className="c-tax-harvesting-general-search__row">
          <div className="c-tax-harvesting-general-search__date">
            <p className="label-multiple-select">Fecha Inicial (último día del año anterior)</p>
            <Input
              type="text"
              name="start_date"
              colorGrey={true}
              defaultValue={startDate}
              onChangeInput={() => {}}
              onFocus={() => {}}
              onBlur={() => {}}
              disabled={true}
            />
          </div>
          <div className="c-tax-harvesting-general-search__date">
            <p className="label-multiple-select">Fecha Final</p>
            <Input
              resource_key="tax_harvesting"
              type="date"
              id="end_date"
              colorGrey={true}
              prepare_dates={datepickerDays}
              onChangeInput={handleValuationDateChange}
              onFocus={() => {}}
              onBlur={() => {}}
            />
          </div>
        </div>


        <div className="c-tax-harvesting-general-search__button">
          <button type="button" className="btn primary" onClick={() => goConsultation()} disabled={consultButtonActive}>
            <span className="btn-text">Consultar</span>
          </button>
          <button type="button" className="btn primary" onClick={goConsultationYear} disabled={consultButtonActive}>
            <span className="btn-text">Consultar año</span>
          </button>
        </div>
        {snapshotGenerationStatus === 'pending' && (
          <p className="c-tax-harvesting-general-search__empty-state">
            No snapshot is available for this date. We are calculating it; this page will update when it is ready.
          </p>
        )}
        {snapshotGenerationStatus === 'failed' && (
          <p className="c-tax-harvesting-general-search__empty-state">
            We could not generate a snapshot for the selected date. Please try again later.
          </p>
        )}
        {noSnapshotForDate && !snapshotGenerationStatus && (
          <p className="c-tax-harvesting-general-search__empty-state">
            No snapshot is available for the selected date.
          </p>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    authentication_token: state.session.authentication_token,
    internalization: state.session.internalization,
    portfolios: state.taxHarvesting.portfolios
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getTaxHarvestingPortfolios: (authentication_token, groupId, success, error) => dispatch(getTaxHarvestingPortfolios(authentication_token, groupId, success, error)),
    getTaxHarvestingSnapshots: (authentication_token, portfolioId, startDate, endDate, success, error) => dispatch(getTaxHarvestingSnapshots(authentication_token, portfolioId, startDate, endDate, success, error)),
    getTaxHarvestingSnapshotById: (authentication_token, snapshotId, success, error) => dispatch(getTaxHarvestingSnapshotById(authentication_token, snapshotId, success, error)),
    getTaxHarvestingSnapshotByDate: (authentication_token, portfolioId, valuationDate, success, error) => dispatch(getTaxHarvestingSnapshotByDate(authentication_token, portfolioId, valuationDate, success, error)),
    createTaxHarvestingSnapshot: (params) => dispatch(createTaxHarvestingSnapshot(params)),
    getTaxHarvestingLots: (authentication_token, snapshotId, tickerSymbol, positionType, page, perPage, success, error) => dispatch(getTaxHarvestingLots(authentication_token, snapshotId, tickerSymbol, positionType, page, perPage, success, error)),
  };
}

export default connect( mapStateToProps, mapDispatchToProps)(TaxHarvestingGeneralSearch);
